import { useState } from "react";
import { FormattedMessage } from "react-intl";
import Button from "@aleaplay/web-components/ui/Button";
import Modal from "@aleaplay/web-components/ui/Modal";

import { catchAsync } from "@/v1/utils/errorHandler";
import { queryClient } from "@/v1/utils/queryClient";
import { useTranslation } from "@/v2/hooks/useTranslation";
import { ITestNewsletterBody, sendNewsletter } from "@/v2/service/testNewsletterService";
import { useTaskManagerStore } from "@/v2/store/useTaskManagerStore";
import { TasksType } from "@/v2/utils/constants";
import { QueryKeys } from "@/v2/utils/queryKeys.constants";

import { TestNewsletterForm } from "./components/templates/TestNewsletterForm/TestNewsletterForm";

interface TestNewsletterModalProps {
  isVisible: boolean;
  onClose: () => void;
}

export const TestNewsletterModal: React.FC<TestNewsletterModalProps> = ({ isVisible, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const setTaskList = useTaskManagerStore((state) => state.setTaskList);

  const handleSubmit = catchAsync(
    async (body: ITestNewsletterBody) => {
      setIsLoading(true);
      const response = await sendNewsletter(body);
      if (response?.status === 201) {
        setTaskList(TasksType.TEST_RELEASE_EMAIL);
        queryClient.removeQueries([QueryKeys.TASKS_QUERY]);
      }
    },
    {
      onSuccessToast: { title: t("label.email-sent-success") },
      onEnd: () => {
        setIsLoading(false);
        onClose();
      },
    },
  );

  return (
    <Modal
      visible={isVisible}
      title={t("label.test-newsletter")}
      actions={[
        <Button key="cancel" modifier="secondary" onClick={onClose}>
          <FormattedMessage id="label.cancel" />
        </Button>,
        <Button key="confirm" form="test-newsletter" modifier="primary" type="submit">
          <FormattedMessage id="label.send" />
        </Button>,
      ]}
      loading={isLoading}
      domNode={document.querySelector("#root")}
      onClose={onClose}
    >
      <TestNewsletterForm handleSubmit={handleSubmit} />
    </Modal>
  );
};
